import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import CmsContext from 'context/CmsContext';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'CONTENTS';

const fields = [
  'IMPORTANT_ANNOUNCEMENT',
  'ABOUT',
  'PRE_ABOUT',
  'PRIVACY_POLICY',
  'TERMS_AND_CONDITION',
  'NPC_SEAL',
  'IMPORTANT_ANNOUNCEMENT_CHECKBOX'
];

function Contents({
  getList,
  createRichTextEditor,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  draftToHtml,
  htmlToDraft,
  convertToRaw,
  createCheckbox
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')

  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    if (item) {
      const retrievedData = JSON.parse(_.get(item, 'attributes.body') || '{}')

      setFormData({
        IMPORTANT_ANNOUNCEMENT: htmlToDraft(_.get(retrievedData, 'IMPORTANT_ANNOUNCEMENT')),
        PRE_ABOUT: htmlToDraft(_.get(retrievedData, 'PRE_ABOUT')),
        ABOUT: htmlToDraft(_.get(retrievedData, 'ABOUT')),
        PRIVACY_POLICY: htmlToDraft(_.get(retrievedData, 'PRIVACY_POLICY')),
        TERMS_AND_CONDITION: htmlToDraft(_.get(retrievedData, 'TERMS_AND_CONDITION')),
        NPC_SEAL: htmlToDraft(_.get(retrievedData, 'NPC_SEAL')),
        id: _.get(item, 'id'),
        IMPORTANT_ANNOUNCEMENT_CHECKBOX: _.get(retrievedData, 'IMPORTANT_ANNOUNCEMENT_CHECKBOX'),
      });
    }

  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const newPayload = {
      ...formData,
      IMPORTANT_ANNOUNCEMENT: draftToHtml(convertToRaw(_.get(formData, 'IMPORTANT_ANNOUNCEMENT').getCurrentContent())),
      PRE_ABOUT: draftToHtml(convertToRaw(_.get(formData, 'PRE_ABOUT').getCurrentContent())),
      ABOUT: draftToHtml(convertToRaw(_.get(formData, 'ABOUT').getCurrentContent())),
      PRIVACY_POLICY: draftToHtml(convertToRaw(_.get(formData, 'PRIVACY_POLICY').getCurrentContent())),
      TERMS_AND_CONDITION: draftToHtml(convertToRaw(_.get(formData, 'TERMS_AND_CONDITION').getCurrentContent())),
      NPC_SEAL: draftToHtml(convertToRaw(_.get(formData, 'NPC_SEAL').getCurrentContent())),
    }

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(newPayload, [...fields])),
      });
    }

    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(newPayload, [...fields])),
    });
  };

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="row">
          <div className="col-12">
            <div className="row">
              {_.get(CMS_VARIABLES, 'LGU_NAME') === 'Las Piñas' ? (
                <>
                  <div className="css-announcement d-flex">
                    {createCheckbox(
                      { key: 'IMPORTANT_ANNOUNCEMENT_CHECKBOX', label: 'IMPORTANT_ANNOUNCEMENT' },
                      { className: 'ml-2 align-items-center align-self-center' }
                    )}
                  </div>
                  <div className="col-12 form-group group-cms-color">
                    {createRichTextEditor(
                      { key: 'IMPORTANT_ANNOUNCEMENT', label: '' },
                      { wrapperClassName: 'border div-css' }
                    )}
                  </div>
                </>
              ) : (
                <div className="col-12 form-group group-cms-color">
                  {createRichTextEditor(
                    { key: 'IMPORTANT_ANNOUNCEMENT', label: '' },
                    { wrapperClassName: 'border div-css' }
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 form-group group-cms-color">
                {createRichTextEditor(
                  { key: 'PRE_ABOUT', label: 'PRE_ABOUT' },
                  { required: true, wrapperClassName: 'border div-css' }
                )}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 form-group group-cms-color">
                {createRichTextEditor(
                  { key: 'ABOUT', label: 'ABOUT' },
                  { required: true, wrapperClassName: 'border div-css' }
                )}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 form-group group-cms-color">
                {createRichTextEditor(
                  { key: 'PRIVACY_POLICY', label: 'PRIVACY_POLICY' },
                  { required: true, wrapperClassName: 'border div-css' }
                )}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 form-group group-cms-color">
                {createRichTextEditor(
                  { key: 'TERMS_AND_CONDITION', label: 'TERMS_AND_CONDITION' },
                  { required: true, wrapperClassName: 'border div-css' }
                )}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 form-group group-cms-color">
                {createRichTextEditor(
                  { key: 'NPC_SEAL', label: 'NPC_SEAL' },
                  { required: true, wrapperClassName: 'border' }
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

Contents.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Contents);
